export default {
    // Track the time to render a new conversation in conversationReadingPane
    // Start from: set conversationReadingPaneViewState
    // End with: the new conversation render complete
    RPPerfRenderConversationReadingPane: {
        datapoint: { name: 'RPPerfRenderConversationReadingPane' },
    },
    // Track the time to render a new item in itemReadingPane
    // Start from: set itemReadingPaneViewState
    // End with: the new item render complete
    RPPerfRenderItemReadingPane: {
        datapoint: {
            name: 'RPPerfRenderItemReadingPane',
            customData: function (itemReadingPaneViewState, itemId, loadedItem, isPreviewPane) {
                return [isPreviewPane];
            },
        },
    },
    // Counts the number of times users collapse the quoted text
    // CustomData: 1 - isQuotedTextChanged
    //             2 - isExpanded
    RPCountExpCollQuotedText: {
        datapoint: {
            name: 'RPCountExpCollQuotedText',
            customData: function (viewState, itemId, isQuotedTextChanged) {
                return [!!isQuotedTextChanged ? 1 : 0, !viewState.isExpanded];
            },
        },
    },
    // Count the number of times user expand/collapse item part
    // CustomData: 1 - itemPartStateChange:
    //                      "SC" - select to collapse,
    //                      "ES" - expand to select,
    //                      "CS" - collapse to select
    RPCountExpCollItemPart: {
        datapoint: {
            name: 'RPCountExpCollItemPart',
            customData: function (itemPart) {
                if (itemPart.isSelected) {
                    return ['SC'];
                }
                else if (itemPart.isExpanded) {
                    return ['ES'];
                }
                else {
                    return ['CS'];
                }
            },
        },
    },
    // Count the number of times user expand/collapse subject
    // CustomData: 1 - isExpanded
    RPCountExpCollSubject: {
        datapoint: {
            name: 'RPCountExpCollSubject',
            customData: function (viewState) {
                return [viewState && !viewState.isSubjectExpanded];
            },
        },
    },
    markItemJunkDatapoint: {
        datapoint: {
            name: 'TnS_JunkItem',
            customData: function (itemId, actionSource) { return [actionSource, itemId]; },
        },
    },
    markItemNotJunkDatapoint: {
        datapoint: {
            name: 'TnS_NotJunkItem',
            customData: function (itemId, actionSource) { return [actionSource, null]; },
        },
    },
    // Counts the number of user click to load more
    RPCountLoadMore: { datapoint: { name: 'RPCountLoadMore' } },
    RPCountConversationCacheState: {
        datapoint: {
            name: 'RPCountConversationCacheState',
            customData: function (cacheState) { return [cacheState]; },
        },
    },
    RPCountReParentingEvent: {
        datapoint: {
            name: 'RPCountReParentingEvent',
            customData: function (draftHasBcc, recipientsOnServer, recipientsAdded, recipientsDropped) { return [draftHasBcc, recipientsOnServer, recipientsAdded, recipientsDropped]; },
        },
    },
    RPCountInfoBar: {
        datapoint: {
            name: 'RPCountInfoBar',
            customData: function (count) { return [count]; },
        },
    },
    deleteMailDatapoint: {
        datapoint: { name: 'TnS_DeleteItem' },
    },
    agendaMailFeedbackDatapoint: {
        datapoint: {
            name: 'AgendaMailFeedback',
            customData: function (feedbackType) { return [feedbackType]; },
        },
    },
    RPCountContinuousCollapsedItems: {
        datapoint: {
            name: 'RPCountContinuousCollapsedItems',
            customData: function (collapsedItemsCountBucket, hiddenGroupCount) { return [
                collapsedItemsCountBucket,
                hiddenGroupCount,
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map